module.exports = __webpack_public_path__ + "img/pg3-article3-c3.0d9e1ecf.png";